// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"caa628be","703":"2b56962d","787":"48fa3d92"}[chunkId] + ".chunk.js";
};